import axiosInstance from 'api/axiosInstance';
import { URL_CANTRACK_GET_PAYROLL_REPORT } from 'constants/urls';
import { PayrollFilters } from './types';

/**
 * Fetches a payroll report with optional type and date filters.
 * @param filters - Payroll filter params (Type, date range, etc.)
 * @returns The API response data (payroll report)
 * @throws Re-throws any Axios error after logging
 */
const getPayroll = async (filters: PayrollFilters = {}) => {
  try {
    const { data } = await axiosInstance.get(
      `${URL_CANTRACK_GET_PAYROLL_REPORT}?payload=${JSON.stringify(filters)}`,
    );
    return data;
  } catch (error) {
    console.error('[getPayroll] Failed:', error);
    throw error;
  }
};

export default getPayroll;
